<template>
  <div class="ml-5 mr-5 mt-5"  id="cloneWaivers">
    <v-row>
      <v-col cols="12">
        <p class="text-left mb-0">{{ $t("cloneWaivers.description") }}</p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="8" class="text-left">
        <v-btn class="btnCE mr-2" @click="clone" small color="primary">{{ $t("cloneWaivers.clone_selected") }}</v-btn>
        <v-btn class="btnCE mr-2" small color="primary" @click="goCreateWaiver">{{ $t("cloneWaivers.add_waivers") }}</v-btn>
        <v-btn
          small
          :color="showDeleted ? 'primary' : 'grey'"
          class="btnCE"
          @click="showDeleted = !showDeleted"
        >
          {{ showDeleted ? $t('cloneWaivers.show-active') : $t('cloneWaivers.show-deleted') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <p class="text-left mb-0">
          <a href="#" class="icon-link"><v-icon small class="mr-2">fas fa-link</v-icon></a>
          {{ $t("cloneWaivers.description_link") }}
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          :label=" $t('clone.search') "
          hide-details
          dense outlined
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-data-table
          v-model="selected"
          :headers="headersClone"
          :search="search"
          :items="filteredWaivers"
          dense
          item-key="id"
          show-select
          :items-per-page.sync="itemsPerPage"
          :no-data-text="$t('dataTable.noDataText')"
          :headerProps="{
            'sort-by-text': $t('dataTable.sortByText')
          }"
          :footer-props="{
            'items-per-page-text': $t('dataTable.rowsPerPageText'),
            'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
          }"
          :no-results-text="$t('dataTable.no_matching_records')"
        >
          <template v-slot:[`item.ageTarget`]="{ item }">
            {{ item.ageTarget ? $t(`common.${item.ageTarget.toLowerCase()}`) : '' }}
          </template>
          <template v-slot:[`item.isPictureRequired`]="{ item }">
            {{ item.isPictureRequired ? $t('common.form.yes') : $t('common.form.no') }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small v-if="!item.isDeleted" class="mr-2" @click="editItem(item)">fas fa-pencil-alt</v-icon>
            <v-icon small v-if="!item.isDeleted" class="mr-2" @click="confirmDelete(item)">fas fa-trash-alt</v-icon>
            <v-icon small v-if="!item.isDeleted" class="mr-2" @click="editItem3(item)">fas fa-link</v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-snackbar v-model="snack" :color="color_snack">{{ msg_snack }}</v-snackbar>
    <SGSNotificationConfirm v-if="dialogNotification" :notificationMessage="$t('common.confirm-delete')" 
    @cancel="dialogNotification=false;" @agree="deleteItem" type='warning' :acept="$t('common.form.delete')" :reject="$t('common.form.cancel')"/>
  </div>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import SGSNotificationConfirm from "@/components/custom/notification/NotificationConfirm.vue";

export default {
  name:"CloneWaiversOld",
  components: {SGSNotificationConfirm},
  mixins: [apiCalls],
  data(){
    return{
      buttonColor: "#000",
      singleSelect: false,
      selected: [],
      waivers:[],
      msg_snack: '',
      snack: false,
      color_snack: 'success',
      search: localStorage.getItem('cloneWaivers_search') || '',
      showDeleted: false,
      itemsPerPage: parseInt(localStorage.getItem('cloneWaivers_itemsPerPage')) || 10,
      userCurrent: null,
      dialogNotification: false,
      item: null
    }
  },
  methods:{
    async clone(){
      this.snack = false;
      if(this.selected.length > 0){
        let _waivers = [];
        this.selected.forEach(x => {
          _waivers.push(x.id);
        });
        let data = {
          ids: _waivers
        }
        const response = await this.api(
          "post",
          "/api/v1/promoter/waivers/copyWaivers",
          data
        );
        if(response.success == 1){          
          this.color_snack = "success";
          this.snack = true;
          this.msg_snack = this.$t("clone.msg_success");
        }else{
          this.snack = true;
          this.color_snack = "error";
          this.msg_snack = this.$t("clone.msg_error");
        }
        this.selected = [];
        this.getWaivers();
      }else{
        this.snack = true;
        this.color_snack = "warning";
        this.msg_snack = this.$t("clone.msg_warning");
      }
    },
    editItem(event){
      this.$router.push({ name: "WaiverEdit",  params: { id:  event.id} });
    },
    editItem3(event){
      this.$router.push({ name: "WaiverEdit",  params: { id:  event.id, step3: 3} });
    },
    async getUser() {
      const getUserCurrent = await this.api("get", "/api/v1/users/current");
      this.userCurrent = getUserCurrent.message;
    },
    async getWaivers() {
      const response = await this.api(
        "get",
        "/api/v1/promoter/waivers/list/" + this.userCurrent.id
      );
      this.waivers = response.message;
    },
    confirmDelete(item) {
      this.item = item;
      this.dialogNotification = true;
    },
    async deleteItem() {
      if(this.item) {
        this.dialogNotification = false;
        const response = await this.api(
          "delete",
          "/api/v1/promoter/waivers/" + this.item.id
        );
        if(response.message) {
          this.getWaivers();
        }
      }
    },
    goCreateWaiver() {
      this.$router.push({ name: 'WaiverCreate' });
    }
  },
  computed:{
    headersClone(){
      return [
        { text: this.$t('cloneWaivers.waiver-id'), value: 'id', sortable: true },
        {
          text: this.$t('cloneWaivers.name'),
          align: 'start',
          sortable: true,
          value: 'name',
        },
        { text: this.$t('cloneWaivers.waiver-type'), value: 'waiverType', sortable: true },
        { text: this.$t('cloneWaivers.age-target'), value: 'ageTarget', sortable: true  },
        { text: this.$t('cloneWaivers.picture-required'), value: 'isPictureRequired', sortable: true },
        { text: this.$t('cloneWaivers.created'), value: 'created_at', sortable: true  },
        { text: this.$t('cloneWaivers.updated'), value: 'updated_at', sortable: true  },
        { text: this.$t('clone.actions'), value: 'actions' },
      ]
    },
    filteredWaivers(){
      return this.waivers.filter(w => this.showDeleted ? w.isDeleted !== false : w.isDeleted === false);
    }
  },
  created: function() {
    this.buttonColor = process.env.VUE_APP_BUTTON_COLOR;
    this.getUser();
  },
  watch: {
    userCurrent(val) {
      if(val) {
        this.getWaivers();
      }
    },
    search(val) {
      localStorage.setItem('cloneWaivers_search', val || '');
    },
    itemsPerPage(val) {
      localStorage.setItem('cloneWaivers_itemsPerPage', val);
    }
  }
}
</script>

<style>
.btnCE{
  color:#fff !important;
}
#cloneEvents .v-data-table{
  margin: 0;
}
#cloneEvents .v-data-table > .v-data-table__wrapper > table > tbody > tr > td{
  font-size: 12px;
  padding: 5px;
}
#cloneEvents .v-data-table > .v-data-table__wrapper > table > thead > tr > th{
  padding: 5px;
}
.custFilter {
  background: var(--v-lighten-base) !important;
}
.filter .v-input {
  font-size: 14px;
}
.filter > .v-input__control {
  background-color: #fff;
}
.filter > .v-input__control > .v-input__slot {
  min-height: 32px !important;
}
.filter .v-label {
    top: 7px !important;
}
.icon-link:focus, .icon-link:hover {
  outline: none;
  text-decoration: none;
}
</style>